import * as React from "react";
const SvgLoan = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 512, height: 512, x: 0, y: 0, viewBox: "0 0 682.667 682.667", style: {
  enableBackground: "new 0 0 512 512"
}, xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "a", clipPathUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("path", { d: "M0 512h512V0H0Z", fill: "#df0000", opacity: 1, "data-original": "#000000" }))), /* @__PURE__ */ React.createElement("path", { d: "M0 0v192.409", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "matrix(1.33333 0 0 -1.33333 161.96 472.413)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("g", { clipPath: "url(#a)", transform: "matrix(1.33333 0 0 -1.33333 0 682.667)" }, /* @__PURE__ */ React.createElement("path", { d: "M0 0v76.4c0 4.42 3.58 8 8 8h294.04c4.42 0 8-3.58 8-8v-402.379c0-4.42-3.58-8-8-8H67.32", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(121.47 385.1)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v27c0 4.42 3.58 8 8 8h294.04c4.42 0 8-3.58 8-8v-210.8", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(156.47 469.5)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v-156.58c0-4.42-3.58-8-8-8h-27", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(466.51 250.7)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0c0-41.477-33.623-75.1-75.1-75.1-41.476 0-75.099 33.623-75.099 75.1s33.623 75.101 75.099 75.101C-33.623 75.101 0 41.477 0 0Z", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(195.69 82.6)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0a18.943 18.943 0 0 0-13.434 5.554l-16.522 16.522c-5.062 5.063-5.443 13.364-.474 18.518 5.062 5.249 13.422 5.304 18.554.173l9.048-9.048a3.997 3.997 0 0 1 5.656 0l28.913 28.913c5.062 5.061 13.363 5.442 18.517.474 5.249-5.062 5.307-13.42.173-18.554L13.435 5.556A18.946 18.946 0 0 0 0 0Z", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(110.451 50.228)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0c5.16-3.369 7.91-3.739 13.779-3.699C28.819-3.6 34.29 17.25 19.5 22.48c-2.08.731-3.98 1.441-5.721 2.151-3.8 1.55-6.809 3.09-9.05 4.84-5.679 4.45-3.599 15.88 4.75 18.389 1.531.46 2.971.691 4.3.75 6.611.321 10.691-3.45 10.691-3.45", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(358.24 279.52)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v7.62", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(372.02 268.2)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v7.07", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(372.02 328.13)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "m0 0 19.638 51.561c.4.98 1.79.982 2.193.002L41.29 0", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(284.722 367.597)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h29.14", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(290.846 380.438)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v52.199L35.292 1.095c.654-.946 1.355-.483 1.355.667v49.561", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(349.8 367.597)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v-52.253c.578-.1 18.313 0 18.313 0", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(166.531 419.894)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0c0-14.441-11.707-26.148-26.148-26.148-14.442 0-26.15 11.707-26.15 26.148 0 14.441 11.708 26.148 26.15 26.148C-11.707 26.148 0 14.441 0 0Z", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(260.932 393.745)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h166.437", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(166.532 335.195)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h166.437", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(166.532 301.7)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h166.437", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(166.532 268.203)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h210.052", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(168.498 234.707)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h81.253", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(168.498 201.21)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0c6.57-20.09 25.47-34.6 47.76-34.6S88.94-20.09 95.51 0", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(273.54 135.33)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0c6.57 20.09 25.47 34.6 47.76 34.6S88.94 20.09 95.51 0", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(273.54 166.61)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h-127.429c-1.897 0-2.728 2.395-1.239 3.57l13.304 10.503a2.002 2.002 0 0 1 0 3.14l-13.304 10.502c-1.489 1.176-.658 3.57 1.239 3.57H0c1.858 0 2.712-2.314 1.298-3.521l-12.42-10.6a2 2 0 0 1 0-3.043l12.42-10.6C2.712 2.315 1.858 0 0 0Z", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(384.444 135.326)", fill: "none", stroke: "#df0000", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }))));
export default SvgLoan;
